export function logout(e) {
  sessionStorage.clear();
  localStorage.clear();

  window.location.reload();
}
